import { render } from "./AppointmentList.vue?vue&type=template&id=22e34cec&scoped=true"
import script from "./AppointmentList.vue?vue&type=script&lang=js"
export * from "./AppointmentList.vue?vue&type=script&lang=js"

import "./AppointmentList.vue?vue&type=style&index=0&id=22e34cec&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e34cec"]])

export default __exports__